import React, { useState } from "react";
import { Typography, Tooltip } from "antd";
import { dineroDisabledMask } from "./Items";
import ModalEditarRelacion from "../Pages/Panel/InsumoProveedor/ModalEditarRelacion/ModalEditarRelacion";
import AyudaConversion from "./AyudaConversion";
/**
 
 * @param {object} props
 * @param {object} props.insumo - El objeto completo del insumo
 * @param {number | string} props.cantidad - La cantidad para la proyección
 * @param {object} [props.colSpans] - Objeto para configurar los colSpans
 * @param {number} [props.colSpans.details=3] - Colspan para la celda de detalles
 * @param {number} [props.colSpans.projection=1] - Colspan para la celda de proyección
 * @param {number} [props.colSpans.filler=8] - Colspan para la celda de relleno
 * @param {function} [props.onCloseModal] - Función que se ejecutara cuando se cierre el Modal
 * @param {boolean} [props.disabledModal] - Boleano para deshabilitar el modal
  */

const InsumoDetalleRow = ({
  insumo,
  cantidad,
  costo,
  colSpans = { details: 3, projection: 1, filler: 8 },
  onCloseModal,
  disabledModal = false,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [relacionId, setRelacionId] = useState(null);
  if (!insumo) {
    return null;
  }

  const handleEditarRelacion = (event) => {
    setRelacionId(insumo._id);
    setModalVisible(true);
  };

  const handleCerrarModal = async () => {
    setModalVisible(false);
    setRelacionId(null);
    if (typeof onCloseModal === "function") {
      await onCloseModal(insumo.proveedorId);
    }
  };

  const renderCalculos = () => {
    const conversionNum = parseFloat(insumo.conversion);
    const cantidadNum = parseFloat(cantidad);
    const precioUnitarioNum = parseFloat(costo);

    let proyeccionJSX = null;
    let costoUnitarioJSX = null;

    if (cantidadNum > 0 && !isNaN(cantidadNum)) {
      const totalObtenido =
        cantidadNum * (isNaN(conversionNum) ? 1 : conversionNum);
      const totalFormateado = totalObtenido.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
      });
      proyeccionJSX = (
        <span>
          {" "}
          Proye: <strong style={{ color: "#1890ff" }}>{totalFormateado}</strong>
        </span>
      );
    }

    if (!isNaN(precioUnitarioNum)) {
      costoUnitarioJSX = (
        <span style={{ marginLeft: proyeccionJSX ? "6px" : "0" }}>
          {proyeccionJSX ? "• " : ""}
          Costo p/Und:{" "}
          <strong style={{ color: "#52c41a" }}>
            {dineroDisabledMask(
              precioUnitarioNum / (isNaN(conversionNum) ? 1 : conversionNum)
            )}
          </strong>
        </span>
      );
    }
    if (!proyeccionJSX && !costoUnitarioJSX) {
      return null;
    }

    return (
      <Typography.Text
        type="secondary"
        style={{ fontSize: "12px", display: "block", textAlign: "left" }}
      >
        <Tooltip
          title="Proyección de la cantidad de insumos que recibirá según su conversión multiplicado por la cantidad solicitada."
          mouseEnterDelay={1.1}
        >
          {" "}
          {proyeccionJSX}
        </Tooltip>
        <Tooltip
          title="Costo por unidad, calculado con el precio unitario entre la conversión"
          mouseEnterDelay={1.1}
        >
          {costoUnitarioJSX}
        </Tooltip>
      </Typography.Text>
    );
  };

  return (
    <>
      <tr className="tr-detalle-insumo">
        <td
          colSpan={colSpans.details}
          className="td-border"
          style={{
            padding: "3px 16px 5px 16px",
            verticalAlign: "top",
            borderTop: "none",
          }}
        >
          <Typography.Text type="secondary" style={{ fontSize: "12px" }}>
            {insumo.clave}
            {insumo.codigoBarras ? ` • CB: ${insumo.codigoBarras}` : ""}
            • {insumo.descripcionInsumo} •{" "}
            {!disabledModal ? (
              <Tooltip
                title="Haz Doble clic para editar la relación."
                mouseEnterDelay={1.1}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                  onDoubleClick={handleEditarRelacion}
                >
                  <strong>Conversión: {insumo?.conversion?.toFixed(4) || "N/A"} </strong>
                </span>
              </Tooltip>
            ) : (
              <span
                style={{
                  fontWeight: "bold",
                  cursor: "text",
                }}
              >
                <strong>Conversión: {insumo?.conversion?.toFixed(4) || "N/A"} </strong>
              </span>
            )}
            <AyudaConversion insumo={insumo} cantidad={cantidad} />{" "}
            Mínima: {insumo.compraMinima || "N/A"}
          </Typography.Text>
        </td>

        <td
          colSpan={colSpans.projection}
          className="td-border"
          style={{
            padding: "3px 8px 5px 8px",
            verticalAlign: "top",
            borderTop: "none",
          }}
        >
          {renderCalculos()}
        </td>

        <td
          colSpan={colSpans.filler}
          className="td-border"
          style={{
            padding: "3px 16px 5px 16px",
            verticalAlign: "top",
            borderTop: "none",
          }}
        ></td>
      </tr>
      {relacionId && (
        <ModalEditarRelacion
          visible={modalVisible}
          relacionId={relacionId}
          onCancel={handleCerrarModal}
          onSuccess={handleCerrarModal}
        />
      )}
    </>
  );
};

export default InsumoDetalleRow;
